<template>
    <div class="row" v-if="isAvailableForView">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-if="!loading" class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">FAQ</div>
                        <a href="/master-admin/settings/faqs/create" class="btn btn--outline-primary btn--middle">+ Add New</a>
                    </div>
                    <div class="mt-4">
                        <div class="table-holder table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th colspan="2">
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('question')">Title of faq<i class="fas fa-sort"></i></a>
                                    </th>
                                    <th class="text-right" style="width: 5rem">Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                    v-for="item in faqList"
                                    :key="item.id"
                                >
                                    <td style="width: 3rem;">
                                        <div class="lines-block">
                                            <div class="line"></div>
                                            <div class="line"></div>
                                        </div>
                                    </td>
                                    <td>
                                        <b>{{item.question}}</b>
                                    </td>
                                    <td class="text-right">
                                        <div class="action-block">
                                            <a
                                                :href="`/master-admin/settings/faqs/${item.id}/update`"
                                                class="edit-link"
                                            ><img src="/img/svg/icons-pen.svg" alt="edit"></a>
                                            <button class="delete-link"
                                                    @click="showDeleteModal(item.id)"
                                            ><img src="/img/svg/on.svg" alt="delete"></button>

                                            <ActionModal confirm-text="Yes" reject-text="No"
                                                         :modalId="getDeleteModalId(item.id)"
                                                         @confirm="deleteItem(item.id)">
                                                <template #body>
                                                    <div class="text-center mb-4">
                                                        <h4>
                                                            Are you sure you want <br> to delete this item?
                                                        </h4>
                                                    </div>
                                                </template>
                                            </ActionModal>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Pagination
                        :currentPage="pagination.current_page"
                        :lastPage="pagination.last_page"
                        @changeItemsPerPage="changeItemsPerPage"
                        @changePage="changePage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import FaqService from "./Services/FaqService";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import SortDirectionHandler from "../../../../../resources/js/mixins/SortDirectionHandler";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";

export default {
    name: 'FaqList',
    props: {
        isAvailableForView: {
            type: Boolean,
            required: true
        },
    },
    components: {ActionModal, Pagination},
    mixins: [DateConverter, ModalHandler, SortDirectionHandler,PaginationHandler],
    data() {
        return {
            faqList: [],
            loading: true,
            filters: {
                page: 1,
                sortBy: 'question',
                sortDir: 'asc',
                perPage: 10
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        getList(filters) {
            this.getFaqList(filters)
        },
        async deleteItem(id) {
            this.faqList = this.faqList.filter((item) => item.id !== id)
            try {
                await FaqService.deleteFaqItem(id)
                this.$showSuccessMessageDelete();
            } catch (error) {
                this.$showErrorMessage();
            }
        },
        async getFaqList() {
            try {
                const { data: response } = await FaqService.getFaqInfo(this.filters)
                this.faqList = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
                this.loading = false

            } catch (e) {
              console.error(e)
                this.$showErrorMessage()
            }
        },
    },
    mounted() {
        this.getFaqList()
    }
}

</script>

<style>

</style>
